import { makeAutoObservable } from "mobx";
import { ITgStore } from "../../store/new-tg-stores";
import { TgModel } from "./tg-model-store";

export interface ITgModelPlaygroundStore {
	compareModels: (TgModel | undefined)[];
	resetPlayground: () => void;
	addCompareModel: () => void;
	removeCompareModel: (index: number) => void;
	updateCompareModel: (index: number, model: TgModel | undefined) => void;
}

export class TgModelPlaygroundStore implements ITgModelPlaygroundStore {
	tgStore: ITgStore;
	compareModels: (TgModel | undefined)[] = [undefined];

	constructor(tgStore: ITgStore) {
		makeAutoObservable(this);
		this.tgStore = tgStore;
	}

	addCompareModel = () => {
		if (this.compareModels.length < 3) {
			this.compareModels.push(undefined);
		}
	};

	removeCompareModel = (index: number) => {
		if (index < this.compareModels.length) {
			this.compareModels.splice(index, 1);
		}
	};

	updateCompareModel = (index: number, model: TgModel | undefined) => {
		if (index >= 0 && index < this.compareModels.length) {
			this.compareModels[index] = model;
		}
	};

	resetPlayground = () => {
		this.tgStore.rootStore.playgroundStore.clearResults();
		this.tgStore.rootStore.textToImageStore.clearConfig();
		this.compareModels = [undefined];
	};
}
